/**
 * Created by dreamc_t on 2017/4/25.
 */
require('./style/index.scss');
require('./style/dark_skin.scss');
// 加入宽屏适配样式
require('./style/wide_screen.scss');

let LiveVideo = require('f.compenont.video.mobile/').liveVideo;
let RecodeVideo = require('f.compenont.video.mobile/').recodeVideo;
let ChartList = require('f.compenont.barrage.mobile/').ChartList;
let DataCenter = require('f.compenont.barrage.mobile/').DataCenter;
let Input = require('f.compenont.barrage.mobile/').Input;
let Message = require('f.compenont.messageCenter');
let ScrollView = require('f.compenont.barrage.mobile/').ScrollView;
let Info = require('./modules/info/');
let MiniInput = require('./modules/miniInput/');
let Util = require('f.core.mobile.util');
let weixinShare = require('f.compenont.weixin.share');
const copy = require('copy-to-clipboard');
import Native from 'f.component.native';
import PresentUI from 'f.component.gift.mobile';
import DianZan from 'f.compenont.dianzan.mobile';
import ShoppingCart from './modules/shoppingCart/';
import LivePage from 'f.component.pagelist.mobile';
import Tab from 'f.compenont.tab.mobile';
import OnlyInfo from './modules/onlypic';
import NoVideo from './modules/noVideo';
import Notice from './modules/notice';
import AdVideo from 'f.component.ad.mobile';
import AdMoney from './modules/adMoney';
import AdTop from './modules/adTop';
import AddCoinTip from './modules/addCoinTip';
import { AntiTheft, createUid } from 'f.component.util';

let Related = require('./modules/relatedNews');
let EventData = require('./modules/eventData');
let SportMatch = require('./modules/sportMatch');

let pull = require('f.compenont.pullup').pull;
let callNewsAPP = require('f.compenont.pullup').callNewsAPP;

let Event = require('f.core.event');
let eventCenter = new Event();

let userType = 'spectator';
let userStatus = 1; // 0是实名，1是未实名
let userAvatar = '';
let userName = '';

let ua = navigator.userAgent;
let weixin = ua.match(/MicroMessenger/gi);
let qq = ua.match(/QQ\/([\d\.]+)/);
let qz = ua.indexOf('Qzone/') !== -1;
let c_from_app = '';

window.adVideoIsEnd = false; // 广告未结束
let isIos = navigator.userAgent.match(/iphone|ipod/gi);
// 检测页面激活，仅针对iOS
let testActive = function () {
    if (isIos) {
        const tt = setInterval(() => {
            if (!document.hidden) {
                // 跳转后回来了
                eventCenter.trigger('page_active');
                clearInterval(tt);
            }
        }, 1000);
    }
};

// 检测触发active事件时，iOS是否真的被激活
let testOnActive = function () {
    if (isIos) {
        if (!document.hidden) {
            eventCenter.trigger('page_active');
        } else {
            return false;
        }
    } else {
        eventCenter.trigger('page_active');
    }
};

let createAd = function (uid, ztname, hasVideo) {
    // debugger;
    Promise.resolve(
        $.ajax({
            url: adParams.adUrl,
            type: 'get',
            dataType: 'json',
            data: {
                ztname: ztname,
                uid: uid
            },
            context: this
        })
    )
        .then(data => {
            let adVideo = null;
            let adMoney = null;
            let adTop = null;
            // debugger;
            if (hasVideo) {
                // 如果页面有前贴片广告
                if (!data[0].adPositionId) {
                    adVideoIsEnd = true;
                }
                adVideo = new AdVideo(data);
            } else {
                adVideoIsEnd = true;
            }
            if (data[3].adPositionId) {
                adTop = new AdTop(data[3], adParams.topCount);
            }

            if (data[4].adPositionId) {
                adMoney = new AdMoney(
                    data[4],
                    adParams.moneyShowCount,
                    adParams.moneyHideCount
                );
            }

            return {
                adVideo,
                adMoney,
                adTop
            };
        })
        .then(({ adVideo, adMoney, adTop }) => {
            if (hasVideo && adVideo) {
                // 如果有前贴片广告
                // debugger

                // '#adinfo#ainfo=10018600:100186003610:piclive_104314$first=yes'
                adVideo.on('adinfo', function ({ ainfo }) {
                    // debugger;
                    let sessionString =
                        '#adinfo#ainfo=' +
                        ainfo +
                        ':piclive_' +
                        __urlParams.liveid +
                        '$first=yes';
                    Native.stat && Native.stat(sessionString, true);
                });

                // '#adclick#loc=10018600$id=100186003610$ch=piclive_104314'
                adVideo.on('adclick', function ({ loc, id }) {
                    // debugger;
                    let sessionString =
                        '#adclick#loc=' +
                        loc +
                        '$id=' +
                        id +
                        '$ch=piclive_' +
                        __urlParams.liveid;
                    console.log(sessionString);
                    Native.stat && Native.stat(sessionString, true);
                });
                // 前贴片广告跳转
                adVideo.on('href_ad', function (url) {
                    url && openUrl(url);
                });
                // 角标广告跳转
                adVideo.on('href_c', function (url) {
                    url && eventCenter.trigger('video_pause');
                    url && openUrl(url);
                });
                // 暂停广告跳转
                adVideo.on('href_p', function (url) {
                    url && openUrl(url);
                });
                // 前贴片广告结束
                adVideo.on('ended', function () {
                    // debugger;
                    if (adVideo.can === 'yes') {
                        adVideo.destory();
                    }

                    eventCenter.trigger('adEnd');
                });

                // 广告暂停后点击广告外内容触发
                adVideo.on('afterAdPause', function () {
                    adVideo.pauseHide();
                    eventCenter.trigger('afterAdPause');
                });
                // 显示暂停广告
                eventCenter.on('pauseAd', function () {
                    // debugger
                    if (adVideoIsEnd) {
                        adVideo.pauseShow();
                    }
                });

                eventCenter.on('cornerAd', function () {
                    adVideo.cornerShow();
                });
                // 前贴片广告开始播放，清掉定时器
                adVideo.on('ad_video_start', () => {
                    adVideo.clearTimer();
                });

                adVideo.on('exit', () => {
                    Native.close && Native.close();
                });

                // 页面被激活后继续播放前贴片广告
                eventCenter.on('page_active', function () {
                    // debugger
                    if (!adVideoIsEnd) {
                        if (!adVideo.start_play) {
                            // 如果广告未开始播放
                            adVideo.setTimer(); // 继续开启5S定时器
                        } else {
                            Native.playVideo(adVideo, adVideo.playIndex);
                        }
                    }
                    if (adMoney) {
                        if (!adMoney.hasShow) {
                            // 如果未出现
                            adMoney.showCountDown(); // 红包广告继续出现时的倒计时
                        } else if (!adMoney.hasHide) {
                            // 如果未隐藏
                            adMoney.hideCountDown(); // 红包广告继续隐藏时的倒计时
                        }
                    }
                });

                eventCenter.on('playAd', function () {
                    adVideo.pauseHide();
                });

                // 页面跳出后
                eventCenter.on('page_exit', () => {
                    if (!adVideoIsEnd) {
                        // 前贴片未结束
                        if (!adVideo.start_play && adVideo.adTimeout) {
                            // 未开始播放，但已开始倒计时
                            adVideo.clearTimer(); // 停止前贴片5秒倒计时
                        }
                        adVideo.pause();
                    }
                    if (adMoney) {
                        if (adMoney.show_timer) {
                            // 如果未出现
                            // adMoney.clearShowCountDown();// 红包广告停止计时
                        } else if (adMoney.hide_timer) {
                            // 如果未隐藏
                            // adMoney.clearHideCountDown();// 红包广告停止计时
                        }
                    }
                });

                if (adVideoIsEnd) {
                    eventCenter.trigger('adEnd');
                }

                if (Native.isApp) {
                    Native.playVideo(adVideo);
                } else {
                    adVideo.play();
                }
            }

            const openUrl = url => {
                if (hasVideo) {
                    // 如果有视频广告
                    // 如果视频广告未播完
                    if (!adVideoIsEnd) {
                        if (!adVideo.cross3 && isIos) {
                            // 如果播放未超过3秒就跳转，就先把播放时间设置为3S
                            adVideo.skip(adVideo.playIndex);
                        }

                        adVideo.pause().then(function () {
                            Native.openWeb(url, true);
                            testActive();
                        });
                    } else {
                        // 视频广告已播完，要让正在播的视频暂停
                        // eventCenter.trigger('video_pause');
                        Native.openWeb(url, true);
                        testActive();
                    }
                } else {
                    Native.openWeb(url, true);
                    testActive();
                }
                eventCenter.trigger('page_exit'); // 提示iOS页面跳出
            };

            /* 点击顶通广告跳转*/
            if (adTop) {
                adTop.on('toggle', function () {
                    eventCenter.trigger('info_toggle');
                });
                adTop.on('top_ad', function (url) {
                    url && openUrl(url);
                });

                // '#adinfo#ainfo=10018600:100186003610:piclive_104314$first=yes'
                adTop.on('adinfo', function ({ ainfo }) {
                    let sessionString =
                        '#adinfo#ainfo=' +
                        ainfo +
                        ':piclive_' +
                        __urlParams.liveid +
                        '$first=yes';
                    Native.stat && Native.stat(sessionString, true);
                });

                // '#adclick#loc=10018600$id=100186003610$ch=piclive_104314'
                adTop.on('adclick', function ({ loc, id }) {
                    // debugger;
                    let sessionString =
                        '#adclick#loc=' +
                        loc +
                        '$id=' +
                        id +
                        '$ch=piclive_' +
                        __urlParams.liveid;
                    Native.stat && Native.stat(sessionString, true);
                });

                adTop.sendStatToApp();
            }

            /* 点击红包跳转*/
            if (adMoney) {
                adMoney.on('money_ad', function (url) {
                    url && openUrl(url);
                });

                // '#adinfo#ainfo=10018600:100186003610:piclive_104314$first=yes'
                adMoney.on('adinfo', function ({ ainfo }) {
                    // debugger;
                    let sessionString =
                        '#adinfo#ainfo=' +
                        ainfo +
                        ':piclive_' +
                        __urlParams.liveid +
                        '$first=yes';
                    Native.stat && Native.stat(sessionString, true);
                });

                // '#adclick#loc=10018600$id=100186003610$ch=piclive_104314'
                adMoney.on('adclick', function ({ loc, id }) {
                    // debugger;
                    let sessionString =
                        '#adclick#loc=' +
                        loc +
                        '$id=' +
                        id +
                        '$ch=piclive_' +
                        __urlParams.liveid;
                    Native.stat && Native.stat(sessionString, true);
                });

                adMoney.sendStatToApp();
            }

            function pull_login() {
                if (hasVideo && !adVideoIsEnd) {
                    adVideo.pause().then(function () {
                        grounds.userLogin();
                        testActive();
                    });
                } else {
                    grounds.userLogin();
                    testActive();
                }

                eventCenter.trigger('page_exit');
            }

            eventCenter.on('pull_login', function () {
                pull_login();
            });
        })
        .catch(err => {
            console.log(`err:${err}`);
            eventCenter.trigger('adEnd'); // 广告资源请求失败，触发广告end
            return false;
        });
};

let createMessage = function (options) {
    let message = new Message(options);

    message.event.on('open', () => {
        eventCenter.trigger('message_open');
    });

    message.event.on('close', () => {
        eventCenter.trigger('message_close');
    });

    message.event.on('begin', () => {
        eventCenter.trigger('message_begin');
    });

    message.event.on('onerror500', function (e) {
        $.ajax({
            url: 'https://data.zhibo.ifeng.com/508df9aec9e2a/data/zbj_count.js',
            type: 'get',
            dataType: 'jsonp',
            cache: true,
            jsonpCallback: 'onlineCallback'
        }).done(function (res) {
            if (res.code === 0) {
                $('.c-visite .num').html(
                    _formatCount(res.data[__urlParams.liveid] || 0)
                );
            }
        });
    });

    eventCenter.on('dataCenter_send', data => {
        message.getUser().then(function (msg) {
            data.forEach(item => {
                Object.assign(item, {
                    __type: 'danma',
                    nickname: msg.nickname,
                    avatar: msg.avatar
                });
            });
            eventCenter.trigger('message_danma_preview', data);
        });
    });

    eventCenter.on('page_destory', () => {
        message.close(false);
    });

    eventCenter.on('page_active', () => {
        message.trytoConnect();
    });

    return message;
};

let createNoVideo = function (info, isLive, native) {
    let noVideo = new NoVideo(info, isLive, native);

    return noVideo;
};

let createOnlyInfo = function (info, message, native) {
    let onlyInfo = new OnlyInfo(info, message, native);
    return onlyInfo;
};

let createNotice = function (info, native, liveid) {
    let notice = new Notice(info, native, liveid);
    return notice;
};

let createInfo = function (info, message, noCount, native) {
    var info = new Info(info, message, noCount, native);
    if (noCount) {
    } else {
    }
    info.on('toggle', () => {
        eventCenter.trigger('info_toggle');
    });
    info.on('login', () => {
        if (adVideoIsEnd) {
            // 广告已结束
            eventCenter.trigger('pull_login_noAds');
        } else {
            eventCenter.trigger('pull_login');
        }
    });

    return info;
};

/*
免流处理
    正常地址
    原访问域名：https://vics.ifeng.com
    订购用户所访问的域名：https://ifvcisifengproxy.iread.wo.com.cn
    防盗链地址
    http://ips.ifeng.com/video19.ifeng.com/video09/
    http://ifipsifengproxy.iread.wo.com.cn/ifvideo19ifengproxy.iread.wo.com.cn
*/
let replaceRes = function (url, type = 'cucc') {
    if (!url) {
        return;
    }
    // url = 'http://zb.ios.ifeng.com/live/0tkdfRNK0_G/index.m3u8';
    // url = url.replace(/^(http|https):/, '');
    let temp = url.split('/');
    // 目前以下两个域名不支持https
    if (
        !(temp[2] === 'ksvod.live.ifeng.com' || temp[2] === 'vod-ali.ifeng.com')
    ) {
        temp[0] = '';
    }

    // 区分电信或者联通免流
    // 联通免流
    if (type === 'cucc') {
        temp[2] =
            'if' +
            temp[2].replace(/(\.com|\.cn)$/, '').replace(/(\.|-)/g, '') +
            'proxy.iread.wo.com.cn';
    }
    // 电信免流
    if (type === 'ctcc') {
        temp[2] =
            'if' +
            temp[2].replace(/(\.com|\.cn)$/, '').replace(/(\.|-)/g, '') +
            'proxy.pt10.cn';
    }

    // 防盗链，两层替换
    if (url.indexOf('ips.ifeng.com') > -1) {
        temp[3] =
            'if' +
            temp[3].replace(/(\.com|\.cn)$/, '').replace(/(\.|-)/g, '') +
            'proxy.iread.wo.com.cn';
    }
    return temp.join('/');
};
let freeFlowHandle = function (list, type = 'cucc') {
    for (let i = 0; i < list.length; i++) {
        let item = list[i];
        if (item.mp4) {
            item.mp4 = replaceRes(item.mp4, type);
        }
        if (item.m3u8) {
            item.m3u8 = replaceRes(item.m3u8, type);
        }
    }
    return list;
};

// 创建一个视频播放器（直播或者回看）
let createVideo = function (config, clientOptions) {
    let options = config.compenonts.video;
    let info = config.info;
    let list = options.list;
    if (
        clientOptions.isFree + '' === 'true' ||
        clientOptions.isFree + '' === 'true_cucc'
    ) {
        list = freeFlowHandle(options.list, 'cucc');
    }
    if (clientOptions.isFree + '' === 'true_ctcc') {
        list = freeFlowHandle(options.list, 'ctcc');
    }
    if (list.length === 0) {
        return;
    }
    list[0].isSelected = true;
    let video = list[0];
    let autoplay = false;

    if (clientOptions.isWifi && clientOptions.isApp) {
        autoplay = true;
    }

    if (!options) {
        return null;
    }

    let c_video;

    if (options.isLive) {
        c_video = new LiveVideo({
            title: info.title,
            src: video.m3u8,
            poster: video.poster,
            start_time: info.start_date,
            start_date: info.start_date,
            end_date: info.end_date,
            list: list,
            channelName: info.channelName,
            channelIcon: info.channelIcon,
            autoplay: autoplay
        });
    } else {
        c_video = new RecodeVideo({
            title: info.title,
            channelName: info.channelName,
            channelIcon: info.channelIcon,
            autoplay: autoplay,
            start_time: info.start_date,
            start_date: info.start_date,
            end_date: info.end_date,
            list: list,
            src:
                video.mp4 +
                '?' +
                AntiTheft({
                    videoinfo: video,
                    gid: createUid(),
                    version: 'vHTML5Player_v2.0.0'
                })
        });
    }

    if (Native.isApp) {
        // debugger;
        if (!adVideoIsEnd) {
            c_video.hide();
        } else {
            // debugger;
            // c_video.show();
            // c_video.load();
            // c_video.play();
        }
    }

    if (!options.isLive) {
        let rangeMax = -1;
        // 如果是回看视频，则需要定义timeupdate事件来获取点播视频的弹幕数据进行显示。
        c_video.on('timeupdate', offset => {
            offset = Math.floor(offset);
            // todo 做一个当前加载过最大弹幕数。
            if (rangeMax < offset) {
                // 通知当前播放的最大时长
                eventCenter.trigger('video_timeupdate_rage', rangeMax, offset);
            }

            // 通知当前的播放时刻
            eventCenter.trigger('video_timeupdate', offset);

            // 记录下来获取数据的最大秒数。
            if (rangeMax < offset) {
                rangeMax = offset;
            }
        });
        c_video.on('hideCount', () => {
            c_video.cutdown.hide();
        });
        c_video.on('switchBarrage', id => {
            // 通知当前视频播放模式切换
            eventCenter.trigger('video_switchBarrage', id);
        });
    }

    c_video.on('shrinkOpen', () => {
        eventCenter.trigger('shrink', { direct: 'up' });
    });

    // 如果不是直播，也不是点播，并且还没到直播时间，才显示倒计时
    let nowTime = new Date().valueOf();

    if (info.start_date > nowTime) {
        // if (Native.isApp) {
        //     Native.playVideo(c_video);
        // } else {
        //     c_video.play();
        // }
        c_video.cutdown.show();
        c_video.cutdown.begin();
    } else {
        if (Native.isApp) {
            Native.playVideo(c_video);
        } else {
            c_video.play();
        }
    }

    c_video.on('controlShow', () => {
        let dge =
            typeof window.orientation !== 'undefined'
                ? window.orientation
                : window.screen.orientation.angle;
        if (Math.abs(dge) === 90) {
            // 通知控制条显示
            eventCenter.trigger('video_controlShow');
        }
    });

    c_video.on('controlHide', () => {
        let dge =
            typeof window.orientation !== 'undefined'
                ? window.orientation
                : window.screen.orientation.angle;
        if (Math.abs(dge) === 90) {
            // 通知控制条隐藏
            eventCenter.trigger('video_controlHide');
        }
    });

    c_video.on('zoom', state => {
        if (state === 'zoomout') {
            if (Native.isApp) {
                Native.rotate(1);
            } else {
                alert('请解除“屏幕旋转”锁定，横屏观看');
            }
        } else {
            if (Native.isApp) {
                Native.rotate(0);
            } else {
                alert('请将手机竖置');
            }
        }
    });

    eventCenter.on('afterAdPause', function () {
        c_video.afterAdPause();
    });

    eventCenter.on('spread', () => {
        // debugger
        c_video.spread();
    });

    eventCenter.on('fold', () => {
        c_video.fold();
    });

    c_video.on('exit', () => {
        // 是否为横屏状态
        const zoomState = $(document.body).hasClass('horizontal');
        if (this.clientOptions.isApp) {
            if (!zoomState) {
                Native.exitMaximization();
                Native.close();
            } else {
                Native.rotate(0);
            }
        } else {
            if (!zoomState) {
                window.location.href = '//izhibo.ifeng.com/home.html';
            } else {
                alert('请将手机竖置');
            }
        }
    });

    c_video.on('cutdownEnd', () => {
        if (Native.isApp) {
            Native.playVideo(c_video);
        } else {
            c_video.play();
        }
    });

    // 显示暂停广告
    c_video.on('pauseAd', function () {
        eventCenter.trigger('pauseAd');
    });

    c_video.on('error', function (msg) {
        let _video = c_video.core.el;
        let _error = _video.error || {};
        console.log(`msg================>${JSON.stringify(_error)}`);
        // if (window.__catchErrorMessage && typeof window.__catchErrorMessage == 'function') {
        //     window.__catchErrorMessage('zhibo_video_error', {
        //         code: _error.code || -1,
        //         message: _error.message || ''
        //     });
        // }
    });

    // 隐藏暂停广告
    c_video.on('playAd', function () {
        eventCenter.trigger('playAd');
    });

    // 页面跳出后
    eventCenter.on('page_exit', () => {
        if (adVideoIsEnd) {
            // 无前贴片
            c_video.pause();
            eventCenter.trigger('pauseAd');
        }
    });

    // 页面跳转后视频暂停
    eventCenter.on('video_pause', () => {
        c_video.pause();
        eventCenter.trigger('pauseAd');
    });

    eventCenter.on('page_active', () => {
        if (options.isLive && adVideoIsEnd) {
            setTimeout(function () {
                c_video.load();
                c_video.play();
            }, 1000);
        }
    });

    eventCenter.on('adEnd', () => {
        // debugger
        c_video.show();
        c_video.load();
        c_video.play();
        adVideoIsEnd = true; // 广告已结束
        eventCenter.trigger('cornerAd');
    });

    let isFirst = true;
    eventCenter.on('networkchange', msg => {
        if (msg === 'none') {
            c_video.network.show('offnet');
        } else if (isFirst && msg !== 'wifi') {
            isFirst = false;
            adVideoIsEnd = true;
            c_video.pause();
            if (grounds && grounds.getDeviceInfo().getProid() === 'videoapp') {
                c_video.network.show('notWifi_videoapp');
            } else {
                c_video.network.show('');
            }
        } else {
            c_video.network.hide();
        }
    });

    eventCenter.on('freeflow', msg => {
        let url_origin = options.isLive
            ? options.list[0].m3u8
            : options.list[0].mp4;
        if (c_video) {
            let url_cur = c_video.getAttribute('src');
            // alert('url_cur--url_origin-' + url_cur + '---' + url_origin)
            if (msg + '' === 'true' || msg + '' === 'true_cucc') {
                // 免流，如已是,则不做处理
                if (url_cur === url_origin) {
                    url_cur = replaceRes(url_origin, 'cucc');
                }
                // alert('true--url_cur-' + url_cur)
            } else if (msg + '' === 'true_ctcc') {
                // 免流，如已是,则不做处理
                if (url_cur === url_origin) {
                    url_cur = replaceRes(url_origin, 'ctcc');
                }
            } else {
                // 不免流，如是免流，则回滚到原地址
                if (url_cur !== url_origin) {
                    url_cur = url_origin;
                }
                // alert('false-url_cur-' + url_cur)
            }
            c_video.setAttribute('src', url_cur);
        }
    });

    return c_video;
};

// 创建一个弹幕数据中心（直播或者点播）
let createDataCenter = function (config, message) {
    let options = config.compenonts.video;
    let barrage = config.compenonts.barrage;
    let title = config.info.title;
    if (options.list.length > 0) {
        barrage.id = options.list[0].liveVideoId;
    }

    let dataCenter;

    if (options.isLive || options.list.length === 0) {
        dataCenter = new DataCenter.Live(__urlParams.liveid, message, title);
    } else {
        dataCenter = new DataCenter.Playback(barrage, message, title);
    }

    // 如果是直播，在获取到数据的时候，将数据插入的弹幕列表和弹幕屏幕上
    dataCenter.on('data', (type, msg) => {
        msg = formatData(type, msg);
        // 通知数据获取
        eventCenter.trigger('dataCenter_data', msg);
    });

    if (options.isLive) {
    } else {
        // 弹幕列表需要获取到播放到当前最大时间的数据。
        dataCenter.on('dataMax', (type, msg) => {
            msg = formatData(type, msg);
            // 通知最大数据获取
            eventCenter.trigger('dataCenter_dataMax', msg);
        });
    }

    // 在发送完弹幕以后，将弹幕回显在弹幕和列表中。
    dataCenter.on('send', data => {
        eventCenter.trigger('dataCenter_send', data);
    });

    eventCenter.on('video_timeupdate_rage', (rangeMax, offset) => {
        dataCenter.getRange(rangeMax, offset);
    });

    eventCenter.on('video_timeupdate', offset => {
        // alert('video_timeupdate');
        dataCenter.getData(offset);
    });

    eventCenter.on('video_switchBarrage', id => {
        dataCenter.reqData(id);
    });

    eventCenter.on('input_message', (data, offset) => {
        dataCenter.sendData(data, offset, 101);
    });

    eventCenter.on('atPerson', msg => {
        dataCenter.sendData(msg, 0, 102);
    });

    eventCenter.on('message_begin', () => {});

    eventCenter.on('message_open', () => {
        eventCenter.trigger('dataCenter_data', [
            {
                avatar: config.info.hosts[0].avatar,
                __type: 'system',
                content: '通讯连接成功'
            }
        ]);
    });

    eventCenter.on('message_close', () => {
        eventCenter.trigger('dataCenter_data', [
            {
                avatar: config.info.hosts[0].avatar,
                __type: 'system',
                content: '糟糕，连接丢失，正在努力恢复通讯...'
            }
        ]);
    });

    return dataCenter;
};

let createChartList = function () {
    let chartList = new ChartList();
    // console.log(chartList)
    // chartList.on('atPerson', function(id){

    //     // var nickname = '';
    //     // var avatar = '';
    //     // if (Native.isApp) {
    //     //     nickname = Native.getUserInfo().getNickname() || '';
    //     //     avatar = Native.getUserInfo().getUserImage() || '';
    //     // }
    //     // const data = {
    //     //     size: 18,
    //     //     color: '0Xffffff',
    //     //     val: `${nickname}@${id}   `,
    //     // };
    //     // data.nickname = nickname;
    //     // data.avatar = avatar;
    //     const value = `@${id}  `;

    //     // var offset = 0;

    //     // if (typeof this.c_video !== 'undefined') {
    //     //     // 这个地方跟video耦合了，不过现在还没想到其他办法解耦，先用条件语句处理一下。
    //     //     offset = Math.round(this.c_video.getCurrentTime());
    //     // }
    //     // console.log('----------------this is @', data)

    //     eventCenter.trigger('input_text', value)
    //     // eventCenter.trigger('atPerson', data)
    // })

    eventCenter.on('info_toggle', () => {
        chartList.resize();
    });

    eventCenter.on('dataCenter_data', msg => {
        // console.log('notice---------', msg)
        if (chartList.isStop) {
            eventCenter.trigger('notice', 'chart');
        }
        chartList.add(msg);
    });

    eventCenter.on('video_switchBarrage', () => {
        chartList.clear();
    });

    eventCenter.on('dataCenter_dataMax', msg => {
        if (chartList.isStop) {
            eventCenter.trigger('notice', 'chart');
        }
        chartList.add(msg);
    });

    eventCenter.on('message_danma_preview', data => {
        chartList.add(data);
    });

    eventCenter.on('input_inputshow', () => {
        chartList.stop();
    });

    eventCenter.on('input_inputhide', () => {
        setTimeout(function () {
            chartList.play();
        }, 1000);
    });

    eventCenter.on('orientationchange_h', () => {
        chartList.stop();
        setTimeout(function () {
            chartList.resize();
        }, 1000);

        // 避免某些安卓机型布局过慢导致第一个resize时机不正确
        setTimeout(function () {
            chartList.resize();
        }, 3000);
    });

    eventCenter.on('changeTab', type => {
        if (type !== 'chart') {
            chartList.stop();
        } else {
            chartList.hideMore();
            chartList.resize();
            chartList.play();
        }
    });

    eventCenter.on('orientationchange_v', () => {
        chartList.hideMore();
        setTimeout(function () {
            chartList.resize();
            chartList.play();
        }, 1000);
    });

    eventCenter.on('fold', () => {
        setTimeout(function () {
            chartList.resize();
        }, 500);
    });

    eventCenter.on('spread', () => {
        setTimeout(function () {
            chartList.resize();
        }, 500);
    });

    return chartList;
};

let createInput = function () {
    let input = new Input({});

    input.on('message', (data, commandid) => {
        let nickname = '';
        let avatar = '';
        if (Native.isApp) {
            nickname = Native.getUserInfo().getNickname() || '';
            avatar = Native.getUserInfo().getUserImage() || '';
        }
        data.nickname = nickname;
        data.avatar = avatar;
        let offset = 0;

        if (typeof this.c_video !== 'undefined') {
            // 这个地方跟video耦合了，不过现在还没想到其他办法解耦，先用条件语句处理一下。
            offset = Math.round(this.c_video.getCurrentTime());
        }

        eventCenter.trigger('input_message', data, offset, commandid);
        input.hide();
    });

    input.on('inputshow', () => {
        $('.p-wrap').addClass('blur');
        // 输入框显示通知
        eventCenter.trigger('input_inputshow');
    });

    input.on('inputhide', () => {
        $('.p-wrap').removeClass('blur');
        // 输入框隐藏通知
        eventCenter.trigger('input_inputhide');
    });

    input.on('text', value => {
        // 通知输入框文字变化
        eventCenter.trigger('input_text', value);
    });

    eventCenter.on('input_message_from_client', data => {
        input.trigger('message', input.getMessageFromClient(data));
    });

    eventCenter.on('input_hide', () => {
        input.hide();
    });

    eventCenter.on('input_show', () => {
        input.show();
    });

    return input;
};

let createScrollView = function () {
    let scrollview = new ScrollView();

    eventCenter.on('video_switchBarrage', () => {
        scrollview.reset();
        scrollview.hide();
        scrollview.pause();
    });

    eventCenter.on('dataCenter_data', msg => {
        scrollview.add(msg);
    });

    eventCenter.on('message_danma_preview', data => {
        scrollview.add(data);
    });

    eventCenter.on('miniInput_unclear', () => {
        scrollview.show();
        scrollview.play();
    });

    eventCenter.on('miniInput_clear', () => {
        scrollview.hide();
        scrollview.pause();
    });

    eventCenter.on('orientationchange_h', () => {
        scrollview.removeData(4);
        scrollview.show();
        scrollview.play();
    });

    eventCenter.on('orientationchange_v', () => {
        scrollview.hide();
        scrollview.pause();
    });

    return scrollview;
};
let getCollectSta = function () {
    let _this = this;
    /** 获取收藏状态
      方法名:isCollected
      参数:json:(可扩充的)
            documentId:文章直播id（唯一标示）
          callback(bool):
                true:已收藏
                false:未收藏
      例如:
        window.grounds.isCollected(JSON.stringify({'documentId':'sub_69472811'}),'isCollectedCallBack')
      */
    window.isCollectedCallBack = function (val) {
        if (val) {
            _this.c_miniInput.isCollected();
        }
    };
    let configInfo = this.config.info;
    if (
        this.clientOptions.isApp &&
        typeof window.grounds.isCollected === 'function'
    ) {
        window.grounds.isCollected(
            JSON.stringify({
                documentId: configInfo.liveid
            }),
            'isCollectedCallBack'
        );
    }
};

let formatUrl = url => {
    if (!url) return;

    url = url.trim();

    if (url.indexOf('http:') === 0) {
        return url.replace('http:', 'https:');
    } else if (url.indexOf('https:') === 0) {
        return url.replace('https:', 'https:');
    } else if (url.indexOf('/') === 0) {
        return url.indexOf('//') === 0 ? 'https:' + url : `https:/${url}`;
    } else {
        return `https://${url}`;
    }
};

let createCollect = function (sta) {
    // console.log('collect_config--', this.config);
    let _this = this;
    window.collectCallBack = function (res) {
        let tip = sta ? '收藏' : '取消收藏';
        if ((res = 'success')) {
            _this.c_miniInput.collect(sta);
        } else {
            alert(tip + '失败');
        }
    };
    // collectCallBack('success')
    let configInfo = this.config.info;
    let link_url =
        window.location.href.indexOf('?') > -1
            ? window.location.href + '&webkit=1'
            : window.location.href + '?webkit=1';
    let collectThumb = formatUrl(configInfo.thumb);
    let _params = {
        documentId: configInfo.liveid,
        title: configInfo.title,
        thumbnail: collectThumb,
        links: [
            {
                type: 'web',
                url: link_url
            }
        ]
    };
    if (
        this.clientOptions.isApp &&
        typeof window.grounds.collect === 'function'
    ) {
        window.grounds.collect(JSON.stringify(_params), sta, 'collectCallBack');
    }
};

let pullapp = function () {
    if (c_from_app === 'videoapp') {
        pull({
            apiUrl:
                '//api.iclient.ifeng.com/wakeupiOS/video/ifengplayer?type=liveroom&id=' +
                __urlParams.liveid +
                '&kind=sf',
            protocolUrl:
                'ifengVideoPlayer://liveroom/' + __urlParams.liveid + '/sf',
            downloadUrl: '//api.3g.ifeng.com/ifengvideo_tg12'
        });
    } else {
        let deepLink =
            'comifengnewsclient://call?remind=1&type=web&id=' +
            encodeURIComponent(window.location.href + '&webkit=1');
        copy(deepLink);
        callNewsAPP(
            {
                download:
                    'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042', // 应用宝地址
                downloadAd:
                    'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641', // 广告下载地址
                domainApi: 'https://api.iclient.ifeng.com/'
            },
            {
                type: 'web', // 拉起类型
                kind: 'share01', // 拉起统计
                ref: encodeURIComponent(location.href + '&webkit=1'), // 端内地址
                id: encodeURIComponent(location.href + '&webkit=1') // 端内地址
            }
        );
    }
};

let createMiniInput = function () {
    let desc = '我要说两句';
    if (__urlParams.liveid == '131498') {
        desc = '发布网络述年评论';
    }
    let miniInput = new MiniInput({ desc: desc });
    // 检测是否已收藏
    miniInput.on('check_isCollected', () => {
        getCollectSta.bind(this)();
    });

    // 当点击底部的聊天区域的时候，弹出输入弹幕的组件。
    miniInput.on('click', e => {
        if ($('body').hasClass('horizontal')) {
            if (Native.isApp) {
                Native.rotate(0);
            }
            $('body').addClass('vertical').removeClass('horizontal');
            eventCenter.trigger('orientationchange_v');
        }
        this.showInput();
    });

    miniInput.on('clear', () => {
        eventCenter.trigger('miniInput_clear');
    });

    miniInput.on('unclear', () => {
        eventCenter.trigger('miniInput_unclear');
    });

    miniInput.on('gift', () => {
        if (!this.clientOptions.isApp && !__urlParams.__debugger) {
            let _val = '打开凤凰新闻，参与精彩互动';

            if (Native.isApp) {
                if (Native.getAppName() == 'videoapp') {
                    _val = '打开凤凰视频，参与精彩互动';
                }
            }

            if (confirm(_val)) {
                pullapp();
            }
        } else {
            eventCenter.trigger('miniInput_gift');
        }
    });
    miniInput.on('collect', sta => {
        if (!this.clientOptions.isApp && !__urlParams.__debugger) {
            let _val = '打开凤凰新闻，参与精彩互动';

            if (Native.isApp) {
                if (Native.getAppName() === 'videoapp') {
                    _val = '打开凤凰视频，参与精彩互动';
                }
            }

            if (confirm(_val)) {
                pullapp();
            }
        } else {
            // 这里收藏是否需要登录还需跟产品沟通，暂时不加登录逻辑，跟客户端统一
            // this.c_message
            //     .getUser()
            //     .then(msg => {
            //             // debugger
            //             if (msg.type == 'guest') {
            //                 eventCenter.trigger('input_hide');
            //                 if (this.clientOptions.isApp) {
            //                     grounds.userLogin();
            //                 } else {
            //                     window.location.href =
            //                         '//id.ifeng.com/muser/login?cb=' + encodeURIComponent(window.location.href.split('#')[0]);
            //                 }
            //             } else {
            //                 createCollect.bind(this)(sta);
            //             }
            //         }
            //     )
            //     .catch(e => { console.log(e); })

            createCollect.bind(this)(sta);
        }
    });
    miniInput.on('exit', () => {
        if (this.clientOptions.isApp) {
            Native.exitMaximization();
            Native.close();
        } else {
            window.location.href = '//izhibo.ifeng.com/home.html';
        }
    });
    let headTitle = config.info.isPolitics ? '直播：' : '风直播：';
    let shareimgUrl = config.info.sharepic;
    if (__urlParams.liveid == '129626') {
        shareimgUrl =
            'http://x0.ifengimg.com/cmpp/2019/1001/9825bcffbc0ae0asize15_w74_h82.png';
    }
    miniInput.on('share', () => {
        if (Native.isApp) {
            Native.openShare(
                window.location.protocol +
                    '//' +
                    window.location.host +
                    window.location.pathname +
                    '?liveid=' +
                    __urlParams.liveid +
                    '&c_from_app=' +
                    c_from_app,
                this.config.info.title,
                this.config.info.intro,
                shareimgUrl,
                __urlParams.liveid
            );
        }
    });

    eventCenter.on('video_controlShow', () => {
        miniInput.hide();
    });

    eventCenter.on('video_controlHide', () => {
        miniInput.show();
    });

    eventCenter.on('input_inputshow', () => {
        miniInput.hide();
    });

    eventCenter.on('input_inputhide', () => {
        miniInput.show();
    });

    eventCenter.on('input_text', value => {
        miniInput.text(value);
    });

    eventCenter.on('orientationchange_h', value => {
        if (this.c_video && !this.c_video.control.isHide) {
            miniInput.hide();
        }
        miniInput.unclear();
    });

    eventCenter.on('orientationchange_v', value => {
        console.log('shu');
        miniInput.show();
    });

    return miniInput;
};

let createZan = function (dianzan_config) {
    let zan = new DianZan(dianzan_config);

    eventCenter.on('video_controlShow', () => {
        zan.hide();
    });

    eventCenter.on('video_controlHide', () => {
        zan.show();
    });

    eventCenter.on('input_inputshow', () => {
        zan.hide();
    });

    eventCenter.on('input_inputhide', () => {
        // 延迟出现点赞，避免闪烁。
        setTimeout(() => {
            zan.show();
        }, 500);
    });

    eventCenter.on('orientationchange_h', () => {
        if (this.c_video && !this.c_video.control.isHide) {
            zan.hide();
        }
    });

    eventCenter.on('orientationchange_v', () => {
        zan.show();
    });

    return zan;
};

let createPresent = function (present_config) {
    let present = new PresentUI(present_config);

    present.event.on('present-login', () => {
        if (Native.isApp) {
            if ($('body').hasClass('horizontal')) {
                Native.rotate(0);
                $('body').addClass('vertical').removeClass('horizontal');
                eventCenter.trigger('orientationchange_v');
            }
            Native.userLogin();
        } else {
            window.location.href =
                '//id.ifeng.com/muser/login?cb=' +
                encodeURIComponent(window.location.href);
        }
    });
    eventCenter.on('present-user-coin', value => {
        present.updateCoin(value);
    });
    eventCenter.on('miniInput_gift', () => {
        present.enter();
    });

    eventCenter.on('orientationchange_h', () => {
        present.hide();
        present.switchOrientation('horizontal');
    });

    eventCenter.on('orientationchange_v', () => {
        present.hide();
        present.switchOrientation('vertical');
    });

    return present;
};

let createLivepage = function (datamodel, native) {
    let livePage = new LivePage(datamodel, native);

    eventCenter.on('changeTab', type => {
        if (type !== 'livepage') {
            livePage.pause(); // isnotice = true 开启提醒
        }
    });

    livePage.on('newMessage', function () {
        eventCenter.trigger('notice', 'livepage');
    });

    livePage.on('shrink', function (params) {
        eventCenter.trigger('shrink', params);
    });

    return livePage;
};
let createSportMatch = function (config, message, container) {
    return new SportMatch(config.info, message, container);
};
let createEventData = function (config) {
    eventCenter.on('changeTab', type => {
        if (type !== 'eventData') {
            // 取消定时
            this.c_eventData &&
                this.c_eventData.timerForEvent &&
                this.c_eventData.endPolling(this.c_eventData.timerForEvent);
        } else {
            this.c_eventData.renderTo(
                document.querySelector('.c-slider__item--active')
            );
        }
    });
    return new EventData(config.info);
};
let createRelated = function (config, native) {
    eventCenter.on('changeTab', type => {
        if (type === 'related') {
            this.relatedTimer = setInterval(() => {
                if (document.getElementById('slider_related')) {
                    this.c_related.renderTo(
                        document.getElementById('slider_related')
                    );
                    clearInterval(this.relatedTimer);
                }
            }, 0);
        }
    });
    return new Related(config, native);
};

let createTab = function (pagelist, chart, eventData, related, isfold) {
    let tab = new Tab();
    if (pagelist) {
        tab.add('图文直播', pagelist, 'livepage');
    }
    if (chart) {
        tab.add('热聊', chart, 'chart');
    }
    if (eventData) {
        tab.add('数据', null, 'eventData');
    }
    if (related) {
        tab.add('相关', null, 'related');
    }

    if (isfold) {
        tab.foldShow();
    } else {
        tab.foldHide();
    }
    tab.on('change', function (type) {
        // 切换标签时通知其他组件开启提醒模式
        eventCenter.trigger('changeTab', type);
    });
    eventCenter.on('notice', function (type) {
        // 有新消息提醒时给对应标题添加标记
        tab.notice(type);
    });
    eventCenter.on('shrink', function (params) {
        // 收缩方向
        const direct = (params && params.direct) || 'down';
        console.log('tab direction: ' + direct);
        if (direct === 'down') {
            tab.trigger('shrink', direct);
            eventCenter.trigger('fold');
        } else {
            const topDistance = (params && params.topDistance) || 0;
            if (topDistance === 0) {
                tab.trigger('shrink', direct);
                eventCenter.trigger('spread');
            }
        }
    });

    if (pagelist || chart || related) {
        tab.active(0);
    }
    // eventCenter.trigger('changeTab',0);

    tab.on('fold', () => {
        eventCenter.trigger('fold');
    });

    tab.on('spread', () => {
        eventCenter.trigger('spread');
    });

    eventCenter.on('orientationchange_h', () => {
        tab.spread();
    });

    return tab;
};

let Page = function (config, clientOptions) {
    this.config = config;
    this.clientOptions = clientOptions;
    this.init();
};

Page.prototype.init = function () {
    this.initState();
    this.initCompenonts();
    this.initEvent();
    this.render();
    this.afterRender();
};

Page.prototype.initState = function () {
    let ua = navigator.userAgent;
    let weixin = ua.match(/MicroMessenger/gi);
    if (weixin) {
        $('body').addClass('weixin');
    }
    // 夜间模式
    if (Native.isApp) {
        let checkMode = Native.getShowMode();
        if (checkMode === 'night') {
            $('body').addClass('skin-dark');
            mode = 'night';
        } else {
            mode = 'day';
        }
    }
};

Page.prototype.initCompenonts = function () {
    if (Native.isApp) {
        this.config.info.loginid = Native.getUserInfo().getGuid();
        this.config.info.followid = 'zhibo_' + this.config.info.columnId;
        this.config.info.token = Native.getUserInfo().getToken(); // 获取token
    }
    this.config.info.requestUrl = interfaceUrl.relatedUrl;
    this.config.info.liveid = __urlParams.liveid;
    this.config.info.followUrl = interfaceUrl.follow;
    this.config.info.queryFollow = interfaceUrl.queryFollow;
    this.config.info.mode = mode;
    let config = this.config;
    let clientOptions = this.clientOptions;
    let nickname = '';
    let avatar = '';
    if (Native.isApp) {
        nickname = Native.getUserInfo().getNickname() || '';
        avatar = Native.getUserInfo().getUserImage() || '';
    }
    let url = __urlParams.ws || this.config.info.ws;
    let praiseType = (config.info && config.info.praiseType) || '2';

    this.c_message = createMessage.bind(this)({
        url: url,
        roomid: __urlParams.liveid,
        source: 'live',
        deviceid: this.clientOptions.deviceid,
        version: '1.0.0',
        app: 'h5',
        nickname: nickname,
        avatar: avatar,
        praise_type: praiseType,
        deviceid_real: this.clientOptions.deviceid_real,
        os: this.clientOptions.os,
        gv: this.clientOptions.gv,
        proid: this.clientOptions.proid,
        uid: this.clientOptions.deviceid,
        token: this.clientOptions.token
    });

    window.message = this.c_message;

    if (window.showShoppingCart) {
        let c_cart = new ShoppingCart($('body'), { url: window.shoppingUrl });
        $('body').addClass('showShopCart');

        eventCenter.on('video_controlShow', () => {
            c_cart.hide();
        });

        eventCenter.on('video_controlHide', () => {
            c_cart.show();
        });

        eventCenter.on('input_inputshow', () => {
            c_cart.hide();
        });

        eventCenter.on('input_inputhide', () => {
            // 延迟出现点赞，避免闪烁。
            setTimeout(() => {
                c_cart.show();
            }, 500);
        });

        eventCenter.on('orientationchange_h', () => {
            if (this.c_video && !this.c_video.control.isHide) {
                c_cart.hide();
            }
        });

        eventCenter.on('orientationchange_v', () => {
            c_cart.show();
        });
    }

    let changeDianZanMode = function (praiseType) {
        if (praiseType === '1') {
            $('body')
                .removeClass('candleDianzan')
                .removeClass('heartDianZan')
                .removeClass('ratDianZan')
                .addClass('noDianZan');
        } else if (praiseType === '3') {
            $('body')
                .removeClass('candleDianzan')
                .removeClass('heartDianZan')
                .removeClass('ratDianZan')
                .addClass('candleDianzan');
        } else if (__urlParams.liveid == '131498') {
            $('body')
                .removeClass('candleDianzan')
                .removeClass('heartDianZan')
                .removeClass('ratDianZan')
                .addClass('ratDianZan');
        } else {
            $('body')
                .removeClass('candleDianzan')
                .removeClass('heartDianZan')
                .removeClass('ratDianZan')
                .addClass('heartDianZan');
        }
    };

    changeDianZanMode(praiseType);
    window.changeDianZanMode = changeDianZanMode;
    let dianzan_config = Object.assign({}, config.compenonts.dianzan, {
        message: this.c_message,
        clientOptions: this.clientOptions
    });
    if (
        config &&
        config.compenonts &&
        config.compenonts.present.presentInfo &&
        config.compenonts.present.presentInfo.length
    ) {
        let mapPresentId = {
            1: 1,
            2: 21,
            3: 22,
            4: 23,
            21: 21,
            22: 22,
            23: 23
        };
        let mapPresentPrice = {
            1: 1,
            2: 2,
            3: 3,
            20: 1,
            30: 2,
            40: 3
        };
        let _presentInfo = [];
        for (let i = 0; i < config.compenonts.present.presentInfo.length; i++) {
            let item = config.compenonts.present.presentInfo[i];
            _presentInfo.push(item);
            _presentInfo[i].id = mapPresentId[item.id];
            if (item.price) {
                _presentInfo[i].price = mapPresentPrice[item.price];
            }
        }
        config.compenonts.present.presentInfo = _presentInfo;
    }
    let present_config = Object.assign({}, config.compenonts.present, {
        message: this.c_message,
        clientOptions: this.clientOptions
    });

    // let collect_config = Object.assign({}, { message: this.c_message });

    this.c_dataCenter = createDataCenter.bind(this)(config, this.c_message);
    if (config.info.isComment == 0) {
        this.c_chartList = null;
        this.c_scrollview = null;
    } else {
        this.c_chartList = createChartList.bind(this)();
        this.c_scrollview = createScrollView.bind(this)();
    }
    this.c_miniInput = createMiniInput.bind(this)();
    this.c_input = createInput.bind(this)();

    if (praiseType !== '1') {
        // 点赞类型不为1时，加载点赞组件
        this.c_zan = createZan.bind(this)(dianzan_config);
    }
    this.c_present = createPresent.bind(this)(present_config);
    if (Native.isApp && Native.getDeviceInfo().getProid() == 'videoapp') {
        this.c_present = null;
    }

    // this.c_collect = createCollect.bind(this)(collect_config);

    if (config.info.isMatch == 1) {
        this.c_sportMatch = createSportMatch.bind(this)(
            config,
            this.c_message,
            document.querySelector('.l-notice')
        );
        this.c_eventData = createEventData.bind(this)(config);
    } else {
        this.c_sportMatch = null;
        this.c_eventData = null;
    }
    if (config.info.isRelated == 0) {
        this.c_related = null;
    } else {
        this.c_related = createRelated.bind(this)(config, Native);
    }
    let start_date = config.info.start_date;

    this.remainTime = Math.floor(
        (new Date(start_date).valueOf() - new Date().valueOf()) / 1000
    );

    if (this.remainTime > 0) {
        this.c_notice = createNotice(config.info, Native, __urlParams.liveid);
    }
    // debugger;
    if (config.info.hasPage && config.compenonts.video.list.length == 0) {
        // 如果有图文直播没有视频直播
        // debugger;
        if (Native.isApp && status == 0) {
            if (this.remainTime < 0) {
                // 非预告状态
                createAd.bind(this)(getUid(), __urlParams.liveid, false); // 顶通广告+红包广告， false表示无视频广告
                adVideoIsEnd = true;
            } else {
                adVideoIsEnd = true; // 预告状态没有前贴片，直播里的视频保证能播
            }
        } else {
            adVideoIsEnd = true; // 预告状态没有前贴片，直播里的视频保证能播
        }
        this.c_livepage = createLivepage.bind(this)(dataModel, Native);
        this.c_tab = createTab.bind(this)(
            this.c_livepage,
            this.c_chartList,
            this.c_eventData,
            this.c_related,
            true
        );
        this.c_noVideo = createNoVideo.bind(this)(
            config.info,
            config.compenonts.video.isLive,
            Native
        );
    } else {
        // 有视频直播
        if (Native.isApp && status == 0) {
            // debugger
            // if (Native.isApp && status == 0) {
            // if (Native.isApp && this.clientOptions.isWifi && status == 0) {
            // debugger;
            if (this.remainTime < 0) {
                // 非预告状态
                createAd.bind(this)(getUid(), __urlParams.liveid, true); // 顶通广告+红包广告， true表示有视频广告
                adVideoIsEnd = false;
            } else {
                createAd.bind(this)(getUid(), __urlParams.liveid, false); // 顶通广告+红包广告， false表示无视频广告
                adVideoIsEnd = true; // 预告状态没有前贴片，直播里的视频保证能播
            }
        } else {
            adVideoIsEnd = true; // h5页没有前贴片，直播里的视频保证能播
        }
        this.c_video = createVideo.bind(this)(config, clientOptions);
        this.c_onlyInfo = createOnlyInfo.bind(this)(
            config.info,
            this.c_message,
            Native
        );
        if (config.info.hasPage) {
            // 有图文直播
            this.c_livepage = createLivepage.bind(this)(dataModel, Native);
            this.c_tab = createTab.bind(this)(
                this.c_livepage,
                this.c_chartList,
                this.c_eventData,
                this.c_related
            );
        } else {
            // 没有图文直播
            this.c_tab = createTab.bind(this)(
                null,
                this.c_chartList,
                this.c_eventData,
                this.c_related
            );
        }
    }
    this.c_info = createInfo.bind(this)(
        config.info,
        this.c_message,
        config.compenonts.video.isLive,
        Native
    ); // 非直播中时不显示参与人数
};

Page.prototype.initEvent = function () {
    let self = this;

    $('.js_openApp').on('touchend', () => {
        pullapp();
        return false;
    });

    $('.js_openAppClose').on('touchend', () => {
        $('.bottom_app_container').fadeOut();
        return false;
    });

    let changeScrollviewsState = function () {
        let dge =
            typeof window.orientation !== 'undefined'
                ? window.orientation
                : window.screen.orientation.angle;
        if (Math.abs(dge) === 90) {
            $('body').addClass('horizontal').removeClass('vertical');
            eventCenter.trigger('orientationchange_h');
        } else {
            $('body').addClass('vertical').removeClass('horizontal');
            eventCenter.trigger('orientationchange_v');
        }
    };

    changeScrollviewsState();
    window.addEventListener('orientationchange', () => {
        changeScrollviewsState();
    });

    //   $(window).on("resize", () => {
    //     if (window.innerWidth > 550) {
    //       document.body.classList.remove("wideScreen");
    //       document.body.classList.add("wideScreen");
    //     } else {
    //       document.body.classList.remove("wideScreen");
    //     }
    //   });

    Native.on('exit', () => {
        eventCenter.trigger('page_exit');
    });

    Native.on('slip', state => {
        if (state == 'out') {
            self.c_video.pause();
        } else if (state == 'in') {
            // self.c_video.load();
            self.c_video.play();
        }
    });

    Native.on('active', () => {
        if (
            typeof navigator.onLine !== 'undefined' &&
            navigator.onLine === false
        ) {
            eventCenter.trigger('networkchange', 'none');
        }
        testOnActive();
    });

    Native.on('destory', () => {
        eventCenter.trigger('page_destory');
    });

    eventCenter.on('fold', () => {
        $('.l-video').addClass('shrinkin_anim');
        $('.l-video').removeClass('shrinkout').addClass('shrinkin');
        $('.l-onlyInfo').show();
        $('.l-head').removeClass('large').addClass('small');
        $('.l-info').hide();
        setTimeout(function () {
            $('.l-video').removeClass('shrinkin_anim');
        }, 400);
    });

    eventCenter.on('spread', () => {
        $('.l-video').addClass('shrinkin_anim');
        $('.l-onlyInfo').hide();
        $('.l-video').removeClass('shrinkin').addClass('shrinkout');
        $('.l-head').removeClass('small').addClass('large');
        $('.l-info').show();
        setTimeout(function () {
            $('.l-video').removeClass('shrinkin_anim');
        }, 400);
    });

    Native.on('networkchange', msg => {
        eventCenter.trigger('networkchange', msg);
    });

    Native.on('freeflow', msg => {
        eventCenter.trigger('freeflow', msg);
    });

    $('.l-noVideo').on('touchstart', function () {
        return false;
    });
    $('.l-onlyInfo').on('touchstart', function () {
        return false;
    });

    // 无广告状态下拉起登录
    eventCenter.on('pull_login_noAds', function () {
        if (self.c_video) {
            self.c_video.pause();
        }
        eventCenter.trigger('page_exit');
        if (grounds && grounds.userLogin) {
            grounds.userLogin();
        }
        testActive();
    });
};

Page.prototype.showInput = function () {
    if (!this.clientOptions.isApp && !__urlParams.__debugger) {
        if (confirm('打开凤凰新闻，参与精彩互动')) {
            pullapp();
        }
        return;
    }

    // 因为checkSid在验证sid合法性的时候，会进行一次异步请求，这样会导致输入框获取不到焦点，
    // 这里将逻辑改成将输入框从认证回调中拿到外面，保证输入框能够正常获得焦点。

    window.inputFromClient = function (data) {
        let _data = JSON.parse(data);
        let text = _data.text.trim();
        if (!text == '') {
            eventCenter.trigger('input_message_from_client', text);
        }
    };

    window.inputFromClientByMaster = function (data) {
        // {text:"", picurl:{url:""}, audiourl:{url:""}
        // url = null 就是没有上传，上传成功了就是url地址, 失败就是‘error’
        let { text, picurl, audiourl } = JSON.parse(data);
        if (picurl.url == 'error') {
            alert('图片上传失败');
            return;
        }

        if (audiourl.url == 'error') {
            alert('音频上传失败');

            return;
        }

        if (
            text == '' &&
            (picurl.url == '' || picurl.url == 'null') &&
            (audiourl.url == '' || audiourl.url == 'null')
        ) {
            return;
        }

        let { token, time } = Native.getTokenAndTimestamp(__urlParams.liveid);

        let params = {
            lr_id: __urlParams.liveid,
            uid: Native.getUserInfo().getGuid(),
            host_name: userName,
            host_avatar: userAvatar,
            token,
            time,
            content: text
        };

        if (picurl.url !== '' && picurl.url !== 'null') {
            params.img = [{ o_src: picurl.url }];
        }

        if (audiourl.url !== '' && audiourl.url !== 'null') {
            params.audio = [
                {
                    duration: audiourl.dur || 0,
                    src: audiourl.url
                }
            ];
        }

        addSourceToServer(params).then(res => {
            if (res.code == 0) {
                alert('成功提交信息');
            } else {
                alert('提交信息失败');
            }
        });
    };

    let _inputCallbackName = 'inputFromClient';

    // debugger
    this.c_message
        .getUser()
        .then(
            function (msg) {
                // debugger
                if (msg.type == 'guest') {
                    eventCenter.trigger('input_hide');
                    if (this.clientOptions.isApp) {
                        grounds.userLogin();
                    } else {
                        window.location.href =
                            '//id.ifeng.com/muser/login?cb=' +
                            encodeURIComponent(
                                window.location.href.split('#')[0]
                            );
                    }
                } else {
                    if (userStatus == 1) {
                        // window.location.href = '//id.ifeng.com/muser/bind?cb=' + window.location.href;
                        if (this.clientOptions.isApp) {
                            if (grounds.userBind) {
                                if (
                                    grounds.getDeviceInfo().getProid() ==
                                    'videoapp'
                                ) {
                                    window.location.href =
                                        '//id.ifeng.com/muser/bind?cb=' +
                                        encodeURIComponent(
                                            window.location.href.split('#')[0]
                                        );
                                } else {
                                    grounds.userBind();
                                }
                            } else {
                                window.location.href =
                                    '//id.ifeng.com/muser/bind?cb=' +
                                    encodeURIComponent(
                                        window.location.href.split('#')[0]
                                    );
                            }
                        } else {
                            window.location.href =
                                '//id.ifeng.com/muser/bind?cb=' +
                                encodeURIComponent(
                                    window.location.href.split('#')[0]
                                );
                        }
                        return;
                    }

                    let _params = { limit: 200, author: 'false' };

                    if (userType == 'master') {
                        _params.author = 'true';
                        _inputCallbackName = 'inputFromClientByMaster';
                    }

                    if (
                        this.clientOptions.isApp &&
                        typeof window.grounds.input === 'function'
                    ) {
                        window.grounds.input(
                            JSON.stringify(_params),
                            _inputCallbackName
                        );
                    }
                }
            }.bind(this)
        )
        .catch(function () {});

    if (
        this.clientOptions.isApp &&
        typeof window.grounds.input === 'function'
    ) {
    } else {
        eventCenter.trigger('input_show');
    }
};

Page.prototype.render = function () {
    if (this.c_onlyInfo) {
        this.c_onlyInfo.renderTo(document.querySelector('.l-onlyInfo'));
    }
    if (this.c_notice && Native.isApp) {
        this.c_notice.renderTo(document.querySelector('.l-notice'));
    }
    if (this.c_video) {
        this.c_video.renderTo(document.querySelector('.l-video'));
    }
    if (this.c_info) {
        this.c_info.renderTo(document.querySelector('.l-info'));
    }
    if (this.c_noVideo) {
        this.c_noVideo.renderTo(document.querySelector('.l-noVideo'));
        $('.l-head').hide();
        $('.l-noVideo').show();
    }
    this.c_miniInput.renderTo(document.querySelector('.l-bottom'));
    this.c_input.renderTo(document.querySelector('body'));
    if (this.c_scrollview) {
        this.c_scrollview.renderTo(document.querySelector('.l-scrollview'));
    }
    if (this.c_sportMatch) {
        this.c_sportMatch.renderTo(document.querySelector('.l-notice'));
    }
    this.c_tab.renderTo(document.querySelector('.l-tab'));
};

// 渲染完成后，做一系列组件的操作
Page.prototype.afterRender = function () {
    let isLive = this.config.compenonts.video.isLive;
    this.c_present &&
        this.c_present.setVerticalEffectTop(
            $('.top_app_container').height() +
                $('.l-video').height() +
                10 +
                'px'
        );

    if (!this.clientOptions.isApp) {
        this.c_miniInput.hideShare();
    } else {
        this.c_miniInput.checkIsCollected();
        if (config.info.isComment == 0) {
            this.c_miniInput.hideInputAndGift();
            this.c_miniInput.showBackAndShare();
        }
    }
    if (Native.isApp && Native.getDeviceInfo().getProid() == 'videoapp') {
        if (this.c_miniInput) {
            this.c_miniInput.hideGift();
        }
    } else {
        beginTime();
    }

    this.c_miniInput.hideCollect();

    if (Native.isApp && Native.getDeviceInfo().getProid() === 'ifengnews') {
        this.c_miniInput.showCollect();
    }

    // 如果是直播，弹幕轮询接收开启
    if (isLive) {
        this.c_dataCenter.start();
    }

    setTimeout(() => {
        this.c_info.introHide();
    }, 3000);

    // 重新设置弹幕列表的尺寸。
    if (this.c_chartList && this.c_chartList.resize) {
        this.c_chartList.resize();
    }
};

/* 计时加金币begin：每个直播观看满2分钟可获得3金币，每个直播每天只能获得一次金币，每天最多可以有2个直播获得金币。*/
window.timeAddCoinCallback = function (res) {
    let resObj = JSON.parse(decodeURIComponent(res));
    if (resObj.code != 200) {
        return;
    }
    let current_point = resObj && resObj.data && resObj.data.current_point;
    let addCoinTip = new AddCoinTip({ point: resObj.data.op_code });
    eventCenter.trigger('present-user-coin', current_point);
};

var beginTime = function () {
    setTimeout(function () {
        if (window.grounds && window.grounds.requestBridge) {
            let guid = window.grounds.getUserInfo().getGuid();
            let deviceid = window.grounds.getDeviceInfo().getDeviceId();
            window.grounds.requestBridge(
                ADD_COIN_API + 'api_user_livecredit/addbyviewlive',
                JSON.stringify({
                    guid: guid,
                    deviceid: deviceid,
                    liveid: __urlParams.liveid
                }),
                '',
                'post',
                true,
                'timeAddCoinCallback'
            );
        }
    }, 120000); // 120000
};
/* 计时加金币end */

let getUserStatus = function () {
    // debugger
    let sid = Util.cookie.getByEncode('sid');

    if (Native.isApp) {
        sid = grounds.getUserInfo().getToken();
    }

    if (sid) {
        $.ajax({
            url: '//id.ifeng.com/api/checklogin',
            type: 'get',
            dataType: 'jsonp',
            data: {
                sid: sid
            }
        }).done(msg => {
            if (
                msg.code == 1 &&
                msg.data &&
                Number(msg.data.realNameStatus) == 0
            ) {
                userStatus = 0;
            } else {
                userStatus = 1;
            }
        });
    } else {
        userStatus = 1;
    }
};

let getCurrentUserType = function (page) {
    let _this = this;
    $.ajax({
        url: interfaceUrl.getlrinfo2,
        type: 'get',
        dataType: 'jsonp',
        cache: true,
        jsonpCallback: 'lrinfoCallback',
        data: { lr_id: __urlParams.liveid }
    })
        .done(res => {
            try {
                // page.c_miniInput.hideBackAndShare();
                // page.c_miniInput.showInput();
                let hosts = res.content.extra.o_hosts;
                let guid = Native.getUserInfo().getGuid();
                // page.c_miniInput.showInput();
                if (hosts && hosts.length) {
                    let _host = hosts.filter(host => host.id == guid);
                    if (_host.length > 0) {
                        userType = 'master';
                        userAvatar = _host[0].avatar;
                        userName = _host[0].name;
                        // debugger
                        page.c_miniInput.hideBackAndShare();
                        page.c_miniInput.showInput();
                    }
                }
            } catch (err) {
                console.log(err);
            }
        })
        .fail(err => {
            console.log(err);
        });
};

// 根据id获取礼物
let getGift = function (id) {
    let gifts = config.compenonts.present.presentInfo.map(function (item) {
        // 兼容历史数据
        let idsObj = {
            2: 21,
            3: 22,
            4: 23
        }; // 新旧id映射
        item.id = idsObj[item.id] || item.id;
        return item;
    });
    for (let i = 0, iLen = gifts.length; i < iLen; i++) {
        if (gifts[i].id == id) {
            return gifts[i];
        }
    }
    return {};
};

var formatData = function (type, datas) {
    switch (type) {
        case 'gift':
            datas.forEach(function (item) {
                let gift = getGift(item.gift.id);
                item.gift.desc = gift.name;
                item.gift.src = gift.pic;
            });
            break;
        case 'online':
            datas.forEach(function (item) {
                item.avatar = config.info.hosts[0].avatar;
            });
            break;
        default:
    }
    return datas;
};

// 创建一个userid
function getRandomUid() {
    let date = new Date().getTime(),
        uid = '',
        fn = '',
        sn = '';

    fn = ((Math.random() * 2147483648) | 0).toString(36);
    sn = Math.round(Math.random() * 10000);
    uid = date + '_' + fn + sn;
    return uid;
}

var getUid = function () {
    let uid = Util.cookie.getByEncode('userid');
    if (!uid) {
        uid = getRandomUid();
    }
    Util.cookie.setByEncode('userid', uid, {
        domain: '.ifeng.com',
        path: '/',
        expires: 60 * 24 * 360
    });
    return uid;
};

let initState = function () {
    if (Native.isApp) {
        let pageType = 'vlive';
        let type = 'vliving';
        if (config.info.preset != 'video') {
            pageType = 'piclive';
            type = 'picliving';
        }
        Native.pageStat(
            pageType + '_' + __urlParams.liveid,
            __urlParams.ref || '',
            pageType,
            'liveimg'
        );
        const liveId = __urlParams.liveid;
        const title = config.info.title;
        Native.storeReadHistory({ liveId: liveId, title: title, type: type });
    }

    if (Native.isApp) {
        Native.maximization();
    }

    return new Promise(function (resolve, reject) {
        /**  deviceInfo data **/
        // av: "5.5.4"
        // deviceid: "990006203081418"
        // df: "androidphone"
        // gv: "5.5.4"
        // os: "android_22"
        // proid: "ifengnews"
        // publishid: "5286"
        // screen: "1080x1920"
        // uid: "990006203081418"
        // vt: "5"
        if (Native.isApp) {
            // log('grounds begin ->', new Date().valueOf());
            Promise.all([
                Native.deviceInfo,
                Native.network,
                Native.freeflow
            ]).then(([deviceInfo, msg, freeflow]) => {
                resolve({
                    isWifi: msg == 'wifi',
                    deviceid: deviceInfo.deviceid,
                    deviceInfo: deviceInfo,
                    isApp: true,
                    isFree: freeflow,
                    deviceid_real: Native.getDeviceInfo().getDeviceId(),
                    os: deviceInfo.os,
                    gv: deviceInfo.gv,
                    proid: deviceInfo.proid,
                    uid: deviceInfo.deviceid,
                    guid: Native.getGuid(),
                    token: Native.getUserInfo().getToken() || ''
                });
            });
            setTimeout(function () {
                resolve({
                    isApp: true,
                    isWifi: false,
                    deviceid: getUid(),
                    isFree: false,
                    deviceid_real: Native.getDeviceInfo().getDeviceId(),
                    os: Native.getDeviceInfo().getOs(),
                    gv: Native.getDeviceInfo().getGv(),
                    proid: Native.getDeviceInfo().getProid(),
                    uid: Native.getDeviceInfo().getDeviceId(),
                    guid: Native.getGuid(),
                    token: Native.getUserInfo().getToken() || ''
                });
            }, 1000);
        } else {
            resolve({
                isApp: false,
                isWifi: false,
                deviceid: getUid()
            });
        }
    });
};

let initSpecialScreenState = function () {
    if (Native.isApp) {
        let diggingScreenTop = Native.getStatusBarHeight();
        if (diggingScreenTop) {
            $('.p-wrap').addClass('diggingCamera');
            let diggingStyles = document.createElement('style');
            diggingStyles.type = 'text/css';
            diggingStyles.innerHTML =
                '.vertical .diggingCamera { padding-top: ' +
                diggingScreenTop +
                'px; }';
            document
                .getElementsByTagName('head')
                .item(0)
                .appendChild(diggingStyles);
        }
    }
};

const __init = function () {
    if (typeof config === 'undefined') {
        window.setTimeout(__init, 300);
    } else {
        initState()
            .then(function (clientOptions) {
                // if(typeof config == 'undefined') {
                //     console.log(defaultConfig)
                //     let config = defaultConfig;
                // }
                // status为4 为下线的状态
                // 国庆期间关闭评论弹幕和点赞
                // config.info.isComment = 0;
                // config.info.praiseType = '1';

                // config.info.hasPage = false;
                if (config.info.status === 4) {
                    let jumpUrl = '/404.html';
                    if (document.referrer) {
                        jumpUrl +=
                            '? =' + encodeURIComponent(document.referrer);
                    }
                    window.location.href = jumpUrl;
                }
                if (Native.isApp) {
                    getUserStatus();
                    initSpecialScreenState();
                }
                let _page = new Page(config, clientOptions);
                // debugger;
                if (Native.isApp) {
                    Native.loadFinish();
                    getCurrentUserType(_page);
                }
                initShareInfo();
            })
            .catch(function (e) {
                console.log(e);
                // if(window.__catchErrorMessage && typeof window.__catchErrorMessage == 'function') {
                //     window.__catchErrorMessage('zhibo_error', e.stack);
                // }
            });
    }
};
let __getVideoInfo = function (options) {
    if (options.from && options.from === 'ugc') {
        // console.log('getVideoInfo:ugc');
        // 请求ugc 的视频接口 // ugc 赵璐/于老师
        let msg = options.uid + '@' + options.liveVideoId;
        return $.ajax({
            url: '//api.cmpp.v.ifeng.com/index.php/live/video',
            dataType: 'jsonp',
            data: {
                msg: msg,
                rt: 'js',
                param: 'playermsg'
            }
        });
    } else if (options.from && options.from === 'pmop') {
        // console.log('getVideoInfo:pmop');
        return 0; // 金山，不处理
    } else {
        // console.log('getVideoInfo:mengshuai');
        // 姣艳/孟帅
        let id = options.liveVideoId.split('-')[0]; // 防止间隔号-导致请求报错
        return $.ajax({
            url: '//tv.ifeng.com/h6/' + id + '__callback' + id + '_/video.json',
            type: 'get',
            jsonpCallback: 'callback' + id,
            dataType: 'jsonp'
        });
    }
};
let __antiTheftChain = function (data) {
    let settings = data; // Object.assign(gloableSettings, data);
    let _obj = {
        videoinfo: settings,
        __gid: window.createGid(),
        version: 'izhiboHTML5Player_v1.0.0',
        from: 'izhibo_h5'
    };
    // 生成防盗链
    let antiTheftUrl = antiTheft(_obj);
    return antiTheftUrl;
};
let __antiTheftChainGet = function () {
    let promises = [];

    let video = config.compenonts.video;
    let info = config.info;
    // let from = config.info.from;
    if (!video.isLive) {
        // 回放
        let videos = video.list;
        let listIndex = []; // 不排除多个视频中，其中一个视频地址不是约定的视频地址，所以要记录索引值
        for (let i = 0; i < videos.length; i++) {
            let src = videos[i].mp4; // Mp4地址
            if (src && src.indexOf('.mp4') > -1) {
                // 约定的视频地址，则根据截取的id，获取视频信息
                let id = videos[i].liveVideoId.split('-')[0];
                let promise = Promise.resolve().then(() =>
                    __getVideoInfo(videos[i])
                );
                listIndex.push(i);
                promises.push(promise);
            } else {
                // 非约定的视频地址，忽略，不处理
                continue;
            }
        }
        return Promise.all(promises).then(result => {
            // listIndex 与 result 是同等长度的数组
            for (let i = 0; i < listIndex.length; i++) {
                let index = listIndex[i];
                let data = result[i];
                let videoUrl = videos[index].mp4;
                if (data) {
                    // 不是金山
                    data.vid = videos[index].liveVideoId;
                    videoUrl += __antiTheftChain(data)
                        ? '?' + __antiTheftChain(data)
                        : '';
                }
                // 根据存储的视频索引，替换视频地址
                videos[index].mp4 = videoUrl;
            }
            // console.log('resetVideoSrc===', data);
            return Promise.resolve();
        });
    }
    return Promise.resolve();
};

Promise.resolve().then(__antiTheftChainGet).then(__init);

function addSourceToServer({
    lr_id,
    uid,
    host_name,
    host_avatar,
    token,
    time,
    content,
    img,
    audio
}) {
    let data = {
        lr_id,
        uid,
        host_name,
        host_avatar,
        token,
        time
    };

    if (content) {
        data.content = content;
    }

    if (img && img.length) {
        data.img = img;
    }

    if (audio && audio.length) {
        data.audio = audio;
    }

    return Promise.resolve(
        $.ajax({
            url: interfaceUrl.addSource,
            type: 'get',
            dataType: 'jsonp',
            data
        })
    );
}

function initShareInfo() {
    if (Native.isApp) {
        c_from_app = Native.getAppName();
    } else {
        c_from_app = __urlParams.c_from_app;
    }

    let headTitle = config.info.isPolitics ? '直播：' : '风直播：';

    let shareimgUrl = config.info.sharepic;

    if (__urlParams.liveid == '129626') {
        shareimgUrl =
            'http://x0.ifengimg.com/cmpp/2019/1001/9825bcffbc0ae0asize15_w74_h82.png';
    }

    if (weixin) {
        weixinShare({
            sharetitle: config.info.title,
            sharelink:
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname +
                '?liveid=' +
                __urlParams.liveid +
                '&c_from_app=' +
                c_from_app,
            shareimgUrl: shareimgUrl,
            sharedesc: config.info.intro
        });
    }
    // console.log('qqshare--', setShareInfo, headTitle + config.info.title, shareimgUrl);
    if (qq || qz) {
        setShareInfo({
            title: config.info.title,
            summary: config.info.intro,
            pic: shareimgUrl,
            url:
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname +
                '?liveid=' +
                __urlParams.liveid +
                '&c_from_app=' +
                c_from_app
        });
    }
    if (__urlParams.liveid == '119513') {
        document.title = config.info.title;

        let newNode = document.createElement('img');
        newNode.setAttribute(
            'src',
            '//p1.ifengimg.com/a/2018/0717/001566787246779size8_w74_h82.jpg'
        );
        document.getElementById('pageslt').insertBefore(newNode, null);
    }
}

beforeLoad(__urlParams.liveid);

// 查看新系统是否存在对应直播间
function beforeLoad(liveid){
    var newLink = "";
    try{
        $.ajax({
            url:"http://console.zhibo.ifeng.com/web/getInfoForFenglive?id=" + liveid,
            type: "get",
            async: false,
            success:function(data) {
                if(data.err==0&&data.data.url){
                    newLink = data.data.url;
                }
            }
        })
    }catch(e){}
    if(newLink){
        window.location.href = newLink;
    }
}



// WEBPACK FOOTER //
// ./app/app.js